import Vuex from 'vuex'

const state = {
  alerts: []
}

const actions = {
  setAlert({ commit }, alert) {
    alert.showing = true
    alert.color = alert.color || 'success'
    commit('SET_ALERT', alert)
  },
  setOff({ commit }, idx) {
    commit('SET_OFF', idx)
  },
  close({ commit }, idx) {
    commit('CLOSE', idx)
  }
}

const mutations = {
  SET_ALERT(state, alert) {
    state.alerts = state.alerts.concat(alert)
  },
  SET_OFF(state, idx) {
    state.alerts.splice(idx, 1)
  },
  CLOSE(state, idx) {
    state.alerts.splice(idx, 1)
  }
}

const getters = {
  alerts: (state) => state.alerts
}

export default new Vuex.Store({
  actions,
  mutations,
  getters,
  state
})
